import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export interface Crumb {
  label: string;
  to?: string;
}

export function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav
      aria-label="Breadcrumb"
      className="flex items-center gap-1.5 text-sm text-night-blue/70"
    >
      {items.map((c, i) => (
        <span key={i} className="flex items-center gap-1.5">
          {i > 0 && <ChevronRight size={14} className="text-night-blue/30" />}
          {c.to && i < items.length - 1 ? (
            <Link to={c.to} className="hover:text-leaf-green-ink">
              {c.label}
            </Link>
          ) : (
            <span
              className={
                i === items.length - 1 ? "font-medium text-night-blue" : ""
              }
            >
              {c.label}
            </span>
          )}
        </span>
      ))}
    </nav>
  );
}
